import React from 'react';
import { Link as ReactScrollLink } from 'react-scroll'
import ReactSVG from 'react-svg'

import './index.scss';

import Container from '../../components/Container'

import intro1 from '../../assets/intro1.svg'
import intro2 from '../../assets/intro2.svg'

const Intro = ({ type, title, to }) => (
  <div className="intro">
    <div className="intro__background">
      <span />
      <span />
      <span>
        {type === 'lawyer' && <ReactSVG className="intro__background--lawyer" src={intro1} />}
        {type === 'company' && <ReactSVG className="intro__background--company" src={intro2} />}
      </span>
    </div>
    <Container>
      <div className="intro__content">
        <h3>BEM VINDO AO FUTURO DA RESOLUÇÃO DE CONFLITOS</h3>
        <h1>{title}</h1>
        <p>Quer saber como? <ReactScrollLink to={to} spy={true} smooth={true} duration={500}>Saiba mais</ReactScrollLink></p>
      </div>
    </Container>
  </div>
)

export default Intro;
